export interface UserRequestModel {
  name: string;
  email: string;
  role: string;
  codes: string[];
  email2FAEnabled?: boolean;
  email2FAAddress?: string;
  google2FAEnabled?: boolean;
}
